import { UnitImage } from "@/components/units/unit/info/UnitImage";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { UnitPromotions } from "@/components/units/unit/info/UnitPromotions";
import { useDispatch, useSelector } from "react-redux";
import {
    goBackStep,
    selectCurrentStep,
    setSelectedPromo,
} from "@/features/journey/journeySlice";
import { Step } from "@/types/enums";
import { formatUnitDimensions } from "@/utils/units/format";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { useSteps } from "@/hooks/useSteps.tsx";

export const JourneyHeader = () => {
    const dispatch = useDispatch();
    const { unitGroup, selectedPromo } = useUnitItemContext();

    const currentStep = useSelector(selectCurrentStep);

    const { steps, stepTitle, stepDescription } = useSteps();

    const handleGoBack = () => {
        console.log("current step: ", currentStep);
        console.log("steps: ", steps);
        console.log("going back");
        dispatch(goBackStep());
    };

    const handlePromoChange = (promo: number) => {
        dispatch(setSelectedPromo(promo));
    };

    const { width, length, area, category } = unitGroup.representative_unit;

    const dimensionLabel = formatUnitDimensions(width, length);

    const currentStepIndex = currentStep ? steps.indexOf(currentStep) : -1;
    const currentStepNumber = currentStepIndex + 1;
    const showBackButton = currentStepIndex > 0;
    const showPromotions =
        currentStep !== Step.FUNNEL && currentStep !== Step.VBP;
    const showSqFt = area > 0;

    return (
        <div className="tw:flex tw:flex-wrap">
            <div className="unit-journey__unit-details">
                <UnitImage
                    className="unit-journey__unit-image tw:mr-3 !tw:max-w-[75px]"
                    length={length}
                    width={width}
                    category={category}
                />
                <h4>{dimensionLabel}</h4>
                {showSqFt && <p>({area} sq. ft.)</p>}
            </div>
            <div className="unit-journey__header">
                <h3 className="unit-journey__title tw:font-bold">
                    Grab Your Space Today
                </h3>
                <p className="unit-journey__step-status">
                    Step {currentStepNumber} of {steps.length}
                </p>
                {showBackButton && (
                    <Button
                        className="unit-journey__back-link tw:font-bold"
                        variant="link"
                        onClick={handleGoBack}
                    >
                        Go Back
                    </Button>
                )}
            </div>
            <Separator className="tw:my-4 tw:border-b tw:border-gray-200" />
            <div className="tw:w-full tw:flex tw:flex-row tw:flex-wrap tw:md:flex-nowrap tw:justify-between">
                <div className="unit-journey__step-description">
                    <h3 className="unit-journey__step-title tw:font-bold">
                        {stepTitle}
                    </h3>
                    <p className="unit-journey__step-description">
                        {stepDescription}
                    </p>
                </div>
                <div className="unit-journey__promotions">
                    {showPromotions && (
                        <UnitPromotions
                            promotions={unitGroup.rates.promo_rates}
                            selectedPromo={selectedPromo}
                            onPromoChange={handlePromoChange}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
